var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDairy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.930664 1.61087C1.15944 1.46542 1.42337 1.39426 1.68985 1.40619H34.629C34.8955 1.39426 35.1594 1.46542 35.3882 1.61087V35.5334C35.1594 35.6788 34.8955 35.7499 34.629 35.7381H1.68985C1.42338 35.7499 1.15946 35.6788 0.930664 35.5334L0.930664 1.61087Z",
    stroke: "#7ED957",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6006 35.431L1.71642 1.77974",
    stroke: "#7ED957",
    strokeWidth: 1.6,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1077 16.5404L22.27 10.1872V7.3319C22.2673 7.19226 22.2386 7.05455 22.1857 6.92667C22.1327 6.79878 22.0566 6.6832 21.9615 6.58655C21.8665 6.4899 21.7544 6.41406 21.6317 6.36337C21.509 6.31267 21.3781 6.28812 21.2465 6.29111H15.1634C14.8976 6.28534 14.6406 6.39171 14.4487 6.58686C14.2568 6.782 14.1457 7.04996 14.1399 7.3319V10.1872L12.307 16.5404C12.2779 16.6346 12.2623 16.733 12.2607 16.8321V28.6329C12.2752 29.3047 12.5401 29.943 12.9974 30.408C13.4546 30.873 14.0671 31.1268 14.7004 31.1136H21.7095C22.3429 31.1268 22.9553 30.873 23.4126 30.408C23.8698 29.943 24.1347 29.3047 24.1492 28.6329V16.8321C24.149 16.7332 24.135 16.6349 24.1077 16.5404ZM16.1869 8.37372H20.223V9.26612H16.1869V8.37372ZM15.938 11.3477H20.4719L21.7578 15.7933H14.6521L15.938 11.3477ZM22.1002 28.6329C22.0977 28.7409 22.055 28.8435 21.9815 28.9183C21.9079 28.993 21.8095 29.0339 21.7076 29.032H14.7004C14.5985 29.0339 14.5001 28.993 14.4265 28.9183C14.353 28.8435 14.3103 28.7409 14.3077 28.6329V17.8749H22.1002V28.6329Z",
    fill: "#7ED957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.15918 0.588501)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDairy);
export default __webpack_public_path__ + "static/media/dairy.e40ee6cc9fb58093727078a5548e7190.svg";
export { ForwardRef as ReactComponent };